import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiUser } from '@wix/da-papi-types';
import UserAvatar from '@wix/da-shared-react/pkg/User/Avatar';
import UserLink from '@wix/da-shared-react/pkg/User/Link';

import s from './ExclusiveOwnerDisplay.scss';

interface Props {
  owner: PapiUser;
}

const ExclusiveOwnerDisplay: React.FC<Props> = ({ owner }) => {
  const { t } = useTranslation();
  return (
    <div className={s['root']}>
      {t('deviationSubmit.form.sellExclusive.owner.label', {
        postProcess: ['reactPostprocessor', 'featureBrancher'],
        avatar: <UserAvatar user={owner} size={24} />,
        userLink: <UserLink user={owner} />,
      })}
    </div>
  );
};
ExclusiveOwnerDisplay.displayName = 'ExclusiveOwnerDisplay';

export default ExclusiveOwnerDisplay;
